import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:

import Dropdown from 'bootstrap/js/dist/dropdown';
onFind('[data-bs-toggle="dropdown"]',function (element) {
    new Dropdown(element);
});

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({submitOnChange: matchMedia('(max-width: 767px)').matches});

import * as ajaxFormScrollTop from './scripts/ajax-form-scroll-top';
ajaxFormScrollTop.init();

import * as dropdownPersist from './scripts/dropdown-persist';
dropdownPersist.init();

import * as multiSelect from './scripts/multi-select';
multiSelect.init();

import Collapse from 'bootstrap/js/dist/collapse';
onFind('[data-bs-toggle="collapse"]',function (element) {
    new Collapse(element);
});

import * as overlayToggle from './scripts/overlay-toggle';
overlayToggle.init();


import * as scrollSlider from '@elements/scroll-slider';
scrollSlider.init({
    arrowIconClass: 'icon icon-arrow-right'
});

import * as mixedTeaserScrollSlider from '@elements/scroll-slider';
mixedTeaserScrollSlider.init({
        dots: true,
        arrowIconClass: 'icon icon-arrow-right'
    },{
        base: '.js-scroll-slider-teaser',
        area: '.js-scroll-slider-teaser__area',
        item: '.js-scroll-slider-teaser__item',
        dotsContainer: '.js-scroll-slider-teaser__dots'
    }
);
